@if (alerts.length) {
  <div class="message-bar-overlay">
    @for (alert of alerts; track alert) {
      <ix-message-bar
        [type]="alert.severity"
        [persistent]="false"
        (closeAnimationCompleted)="onDismiss(alert)">
        <ix-typography format="h4">{{ getTitle(alert) }}</ix-typography>
        <ix-typography>{{ getDescription(alert) }}</ix-typography>
      </ix-message-bar>
    }
  </div>
}
